import ConfigurableTable from 'components/shared/table/ConfigurableTable';
import TabHeader from './TabHeader';
import {
  ACCOUNT_TYPE,
  SAMPLE_INSIGHT_BOARDS_COLUMNS,
  GENERAL_INSIGHT_BOARDS_COLUMNS,
  INSIGHT_TYPE,
  PIN_ACTIONS,
  PIN_TOAST_MESSAGES,
  SORT_BY,
  NULL_VALUE,
  BOOLEAN_FALSE,
  NUMBER_ZERO,
  BOOLEAN_TRUE,
  EMPTY_STRING,
} from 'constants/constants';
import { Link } from 'react-router-dom';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import { Tooltip } from 'react-bootstrap';
import { useEffect, useState, useRef } from 'react';
import { searchData } from 'utils/utils';
import ContextPopover from 'components/shared/context-menu/ContextPopover';
import LinkButton from 'components/shared/button/LinkButton';
import classes from './View.module.scss';
import {
  updateInsightBoardTitle,
  deleteInsightBoard,
  shareInsightBoard,
  notifyRecipientByMail,
  updateInsightBoards,
} from 'store/customer/customer-view-actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAppUsers,
  setInsightBoards,
  setNotificationEmailStatus,
  setSelectedCustomer,
} from 'store/customer/customerViewSlice';
import { getTeamMembers } from 'services/configure-priority.service';
import ShareInsightBoard from '../insights/share-insight/ShareInsightBoard';
import { toast } from 'react-toastify';
import CopyInsightBoard from '../insights/copy-insight/CopyInsightBoard';
import EditInsightBoardTitle from '../insights/edit-insight/EditInsightBoardTitle';
import Confirmation from 'components/shared/confirmation/Confirmation';
import { areas } from 'constants/constants';
import { Spinner } from 'components/shared/loader/Spinner';
import { usePromiseTracker } from 'react-promise-tracker';
import './InsightBoardsList.scss';
import PinnedInsightBoards from './PinnedInsightBoards';

const InsightBoardsList = ({ page, insightBoards, onItemClickHandler }) => {
  const dispatch = useDispatch();
  const { unixId } = useSelector((state) => state.Auth.userClaimObject);
  const [filteredBoards, setFilteredBoards] = useState();
  const appActiveUsers = useSelector((state) => state?.CustomerView?.appUsers);
  const tabHeaderRef = useRef();
  const [modalShow, setModalShow] = useState(BOOLEAN_FALSE);
  const [anchorEl, setAnchorEl] = useState();
  const [currentInsight, setCurrentInsight] = useState(NULL_VALUE);
  const [shareModalShow, setShareModalShow] = useState(BOOLEAN_FALSE);
  const [copyModalShow, setCopyModalShow] = useState(BOOLEAN_FALSE);
  const [modalConfirmShow, setConfirmModalShow] = useState(BOOLEAN_FALSE);
  const notifyUsersByEmailList = useSelector(
    (state) => state?.CustomerView?.notifyUsersByEmailList
  );
  const getEmailNotificationStatus = useSelector(
    (state) => state?.CustomerView?.notificationEmailStatus
  );
  const [selectedUsersToNotify, setselectedUsersToNotify] = useState([]);
  const filterOptions = [
    { value: 'All Insight Boards', label: 'All Insight Boards' },
    { value: 'Created By Me', label: 'Created By Me' },
    { value: 'Shared With Me', label: 'Shared With Me' },
  ];
  const { promiseInProgress: loadingViews } = usePromiseTracker({
    area: areas.customerViewList,
  });
  const { promiseInProgress: isPinActionInProgress } = usePromiseTracker({
    area: areas.customerViewPinPatch,
  });
  const [searchCriteria, setSearchCriteria] = useState({
    searchedText: EMPTY_STRING,
    selectedFilter: filterOptions[0].value,
  });
  const isGeneralInsightPage = page === INSIGHT_TYPE.GENERAL;
  const [sortColumn, setSortColumn] = useState('lastModified');
  const [sortOrder, setSortOrder] = useState(SORT_BY.descend);

  const getSortColumnValue = (columnKey) => {
    const sortOrderMap = {
      name: 'name',
      createdDate: 'createdDate',
      lastViewedDate: 'lastModified',
      boardType: 'boardType',
      publisher: 'publisher',
    };

    return sortOrderMap[columnKey] || 'lastModified';
  };

  const getSortDirectionValue = (order) => {
    if (order === 'ascend') return SORT_BY.ascend;
    if (order === 'descend') return SORT_BY.descend;
    return EMPTY_STRING;
  };

  const getBoardPositionIndex = (board) => {
    return board?.insightType === INSIGHT_TYPE.GENERAL && board?.positionIndex;
  };

  const pinnedBoards = filteredBoards
    ?.filter((board) => getBoardPositionIndex(board))
    .sort((a, b) => getBoardPositionIndex(a) - getBoardPositionIndex(b));

  const unpinnedBoards = filteredBoards?.filter(
    (board) => !getBoardPositionIndex(board)
  );

  useEffect(() => {
    handleSearchOrFilter(
      searchCriteria.searchedText,
      searchCriteria.selectedFilter
    );
  }, [insightBoards, page]);

  const getOptionsTosharewith = async () => {
    if (appActiveUsers?.length === NUMBER_ZERO) {
      dispatch(
        setAppUsers(
          await getTeamMembers(currentInsight.accountId, ACCOUNT_TYPE.shared)
        )
      );
    }
  };

  const shareInsightHandler = () => {
    setAnchorEl(NULL_VALUE);
    getOptionsTosharewith();
    setShareModalShow(BOOLEAN_TRUE);
  };

  const copyInsightHandler = () => {
    setAnchorEl(NULL_VALUE);
    setCopyModalShow(BOOLEAN_TRUE);
    dispatch(setSelectedCustomer([]));
  };

  const editInsightHandler = () => {
    setAnchorEl(NULL_VALUE);
    setModalShow(BOOLEAN_TRUE);
  };

  const deleteInsightHandler = () => {
    setAnchorEl(NULL_VALUE);
    setConfirmModalShow(BOOLEAN_TRUE);
  };

  const handleSave = async (title) => {
    const insightId = currentInsight?.Id;
    try {
      await updateInsightBoardTitle(title, insightId);
      const insightData = insightBoards?.map((item) => {
        let updatedTitle = item.name;
        if (item.Id === currentInsight.Id) {
          updatedTitle = title;
        }
        return { ...item, name: updatedTitle };
      });

      dispatch(setInsightBoards(insightData));
    } catch (err) {
      console.log(err.message);
    }
    setModalShow(BOOLEAN_FALSE);
  };

  const getColumns = () => {
    const columns = isGeneralInsightPage
      ? GENERAL_INSIGHT_BOARDS_COLUMNS
      : SAMPLE_INSIGHT_BOARDS_COLUMNS;

    return columns.map((col) => {
      if (col.dataIndex === 'name') {
        return {
          ...col,
          title: (
            <span
              className={`${isGeneralInsightPage ? 'ms-4 p-2' : EMPTY_STRING}`}>
              {col.title}
            </span>
          ),
          render: (_, record) => (
            <span className='d-flex align-items-center span-link text text__normal text__bold ms-1'>
              {isGeneralInsightPage && (
                <i
                  onClick={(e) => {
                    if (isPinActionInProgress) return;
                    handlePinClick(e, record);
                  }}
                  className={`icon ${getPinIconClass(record)} me-3 flex-shrink-0`}></i>
              )}
              <span className='flex-grow-1 text-wrap text-break'>
                <Link
                  to={record.name}
                  onClick={onItemClickHandler.bind(this, record)}>
                  {record.name}{' '}
                </Link>
              </span>
              {record.sharedBy ? (
                <span className='ms-2 flex-shrink-0'>
                  <OverlayTrigger overlay={tooltip(record.sharedBy)}>
                    <i className='icon icon__sharedby'></i>
                  </OverlayTrigger>
                </span>
              ) : (
                EMPTY_STRING
              )}
            </span>
          ),
        };
      }
      return col;
    });
  };

  const tooltip = (sharedBy) => {
    return (
      <Tooltip
        className='gne-tooltip'
        bsclass='gne-tooltip tooltip__white'>
        <p className='text text__x-small mb-1'>
          <b>Shared by: </b>
          {sharedBy}
        </p>
      </Tooltip>
    );
  };

  const handleSearchOrFilter = (searchedText, selectedFilter) => {
    const normalizedFilter =
      typeof selectedFilter === 'string'
        ? selectedFilter
        : selectedFilter?.value || filterOptions[0].value;

    setSearchCriteria({
      searchedText,
      selectedFilter: normalizedFilter,
    });

    let filterPool = insightBoards.filter((ib) => page === ib.insightType);

    switch (normalizedFilter) {
      case filterOptions[1].value:
        filterPool = filterPool.filter((ib) => ib.sharedBy === NULL_VALUE);
        break;
      case filterOptions[2].value:
        filterPool = filterPool.filter((ib) => ib.sharedBy);
        break;
      default:
        break;
    }

    if (searchedText !== EMPTY_STRING) {
      filterPool = searchData(filterPool, searchedText);
    }
    setFilteredBoards(filterPool);
  };

  const contextContent = (
    <>
      <div
        className='menu-item'
        onClick={shareInsightHandler}>
        <i className={`icon icon__share me-1 ${classes['edit-icon']}`}></i>
        <LinkButton className={classes['context-menu-button']}>
          Share
        </LinkButton>
      </div>
      <div
        className='menu-item'
        onClick={copyInsightHandler}>
        <i className='icon icon__copy-insight me-2'></i>
        <LinkButton className={classes['context-menu-button']}>
          Copy To
        </LinkButton>
      </div>
      <div
        className='menu-item'
        onClick={editInsightHandler}>
        <i
          className={`icon icon__configureEditInsightTile ${classes['edit-icon']}`}></i>
        <LinkButton className={classes['context-menu-button']}>
          Rename Title
        </LinkButton>
      </div>
      <div
        className='menu-item'
        onClick={deleteInsightHandler}>
        <i className='icon icon__delete-insight me-2'></i>
        <LinkButton className={classes['context-menu-button']}>
          Delete
        </LinkButton>
      </div>
    </>
  );

  const onHide = () => {
    setModalShow(BOOLEAN_FALSE);
    setConfirmModalShow(BOOLEAN_FALSE);
  };

  const handleClose = () => {
    setAnchorEl(NULL_VALUE);
  };

  const saveShareInsightHandler = async (shareWith) => {
    const sharedByName = appActiveUsers?.filter(
      (uid) => uid?.unixId.toLowerCase() === unixId.toLowerCase()
    );
    let insightsBoard = {
      insightBorardIdToShare: currentInsight.Id,
      accountId: currentInsight.accountId,
      insightsBoardName: currentInsight.name || currentInsight.accountName,
      isPriorityAccount: currentInsight.isPriorityAccount
        ? currentInsight.isPriorityAccount
        : 'N',
      boardType: currentInsight.boardType,
      sharedBy: sharedByName?.[0]?.label,
    };
    const response = await shareInsightBoard(insightsBoard, shareWith);
    let successMsg = currentInsight.accountName + ' Shared with : ';
    if (!response?.some((item) => item.message !== 'success')) {
      response.map((rs, index) => {
        successMsg += (index ? ', ' : '') + rs.sharedWith;
        return 'success';
      });
      toast.success(successMsg);
      if (getEmailNotificationStatus) {
        saveNotifyInsightHandler(selectedUsersToNotify);
        dispatch(setNotificationEmailStatus(false));
      }
    } else {
      toast.error('Operation Failed');
      return 'success';
    }
  };

  const onDelete = async (id) => {
    try {
      const response = await deleteInsightBoard(id);
      if (response) {
        const insightDataExceptDeleted = insightBoards.filter(
          (item) => item.Id !== id
        );
        dispatch(setInsightBoards(insightDataExceptDeleted));
        if (tabHeaderRef.current) {
          tabHeaderRef.current.clearSearch();
        }
      }
    } catch (err) {
      console.log(err.message);
    }
    setConfirmModalShow(BOOLEAN_FALSE);
  };

  const saveNotifyInsightHandler = async (notifyEmailWith) => {
    const sharedByName = appActiveUsers?.filter(
      (uid) => uid?.unixId.toLowerCase() === unixId.toLowerCase()
    );
    let insightsBoard = {
      insightBorardIdToShare: currentInsight.Id,
      accountId: currentInsight.accountId,
      insightsBoardName: currentInsight.name || currentInsight.accountName,
      isPriorityAccount: currentInsight.isPriorityAccount,
      boardType: currentInsight.boardType,
      sharedBy: sharedByName?.[0]?.label,
    };

    await notifyRecipientByMail(insightsBoard, notifyUsersByEmailList);
  };

  const viewActionHandler = (record, e) => {
    setCurrentInsight(record);
    if (page === INSIGHT_TYPE.SAMPLE) {
      setCopyModalShow(BOOLEAN_TRUE);
    } else {
      setAnchorEl(e.currentTarget);
    }
  };

  const sortData = (columnKey, order) => {
    if (columnKey) {
      setSortColumn(getSortColumnValue(columnKey));
    }
    setSortOrder(getSortDirectionValue(order));
  };

  const handlePinClick = async (e, record, rowIndex) => {
    if (isPinActionInProgress) return;
    e.stopPropagation();
    const action = Boolean(getBoardPositionIndex(record))
      ? PIN_ACTIONS.UNPIN
      : PIN_ACTIONS.PIN;
    const sourceBoard = unpinnedBoards?.[rowIndex] || record;
    try {
      const response = await updateInsightBoards({
        custInsightBrdId: sourceBoard.Id || sourceBoard?.customerInsightBrdId,
        action,
        sortColumn,
        sortOrder,
      });
      if (response?.result) {
        dispatch(setInsightBoards(response?.result));
        toast.success(PIN_TOAST_MESSAGES.success[action]);
        return BOOLEAN_TRUE;
      }

      toast.error(PIN_TOAST_MESSAGES.error[action]);
      return BOOLEAN_FALSE;
    } catch (err) {
      console.log(err.message);
      toast.error(PIN_TOAST_MESSAGES.error[action]);
      return BOOLEAN_FALSE;
    }
  };

  const handleUnpinClick = async (record) => {
    if (isPinActionInProgress) return;
    try {
      const response = await updateInsightBoards({
        custInsightBrdId: record.Id,
        action: PIN_ACTIONS.UNPIN,
        sortColumn,
        sortOrder,
      });
      if (response?.result) {
        dispatch(setInsightBoards(response?.result));
        toast.success(PIN_TOAST_MESSAGES.success[PIN_ACTIONS.UNPIN]);
        return BOOLEAN_TRUE;
      }

      toast.error(PIN_TOAST_MESSAGES.error[PIN_ACTIONS.UNPIN]);
      return BOOLEAN_FALSE;
    } catch (err) {
      console.log(err.message);
      toast.error(PIN_TOAST_MESSAGES.error[PIN_ACTIONS.UNPIN]);
      return BOOLEAN_FALSE;
    }
  };

  const handlePinnedReorder = async (payload) => {
    if (isPinActionInProgress) return;

    if (!payload?.custInsightBrdId) {
      toast.error(PIN_TOAST_MESSAGES.error[PIN_ACTIONS.REORDER]);
      return BOOLEAN_FALSE;
    }

    try {
      const response = await updateInsightBoards({
        ...payload,
        sortColumn,
        sortOrder,
      });
      if (response?.result) {
        dispatch(setInsightBoards(response?.result));
        return BOOLEAN_TRUE;
      }

      toast.error(PIN_TOAST_MESSAGES.error[PIN_ACTIONS.REORDER]);
      return BOOLEAN_FALSE;
    } catch (err) {
      console.log(err.message);
      toast.error(PIN_TOAST_MESSAGES.error[PIN_ACTIONS.REORDER]);
      return BOOLEAN_FALSE;
    }
  };

  const getPinIconClass = (record) => {
    return getBoardPositionIndex(record)
      ? 'icon__pin_active'
      : 'icon__pin_disabled';
  };

  return (
    <>
      <TabHeader
        ref={tabHeaderRef}
        page={page}
        handleSearch={handleSearchOrFilter}
        filterViewOptions={filterOptions}
      />
      {isGeneralInsightPage && (
        <PinnedInsightBoards
          pinnedBoards={pinnedBoards}
          onItemClickHandler={onItemClickHandler}
          onActionClick={viewActionHandler}
          onUnpin={handleUnpinClick}
          onReorder={handlePinnedReorder}
          sharedByTooltip={tooltip}
          isPinActionInProgress={isPinActionInProgress}
          searchedText={searchCriteria.searchedText}
        />
      )}

      {loadingViews ? (
        <Spinner />
      ) : (
        <div className='mt-3'>
          <ConfigurableTable
            tableName={'myViews'}
            rows={unpinnedBoards}
            pagination={false}
            columns={getColumns()}
            onSort={sortData}
            showActionIcon={true}
            actionColumnTitle='Actions'
            actionColumnWidth={110}
            onActionClickHandler={viewActionHandler}
            customCss='insights-board'
            dimentions={{ x: 800 }}
            iconProps={{
              iconCss: isGeneralInsightPage ? 'card-toggle' : 'copy-insight',
            }}
            showWarning={!unpinnedBoards?.length && searchCriteria.searchedText}
            customEmptyComponent={
              <p className='d-flex text text__small text__black align-items-center mb-4 mt-4 justify-content-center'>
                No search results to display.
              </p>
            }
          />
        </div>
      )}
      <ContextPopover
        anchor={anchorEl}
        onHandleClose={handleClose}
        content={contextContent}
        placement='bottomRight'
      />
      <ShareInsightBoard
        showModal={shareModalShow}
        setShowModal={setShareModalShow}
        currentInsight={currentInsight}
        dropdownShareOptions={appActiveUsers}
        saveShareInsightHandler={(shareWith) => {
          saveShareInsightHandler(shareWith);
        }}
        saveNotifyInsightHandler={(notifyWithshare) => {
          if (notifyWithshare?.length) {
            setselectedUsersToNotify(notifyWithshare);
          }
        }}
      />
      <CopyInsightBoard
        showModal={copyModalShow}
        setShowModal={setCopyModalShow}
        currentInsight={currentInsight}
      />
      <EditInsightBoardTitle
        show={modalShow}
        handleSave={handleSave}
        onHide={onHide}
        title={currentInsight?.name}
        insightAccountId={currentInsight?.Id}
      />
      <Confirmation
        show={modalConfirmShow}
        onOK={onDelete}
        onHide={onHide}
        id={currentInsight?.Id}
      />
    </>
  );
};

export default InsightBoardsList;
